import React, {
    useState,
    useRef,
    useEffect
} from "react";

import { createPortal } from "react-dom";

import useTooltipPosition from "./useTooltipPosition";

import {
    TooltipWrapper,
    TooltipContainer,
    TooltipBubble,
    TooltipArrow
} from "./Tooltip.styles";

const Tooltip = ({
    children,

    content,

    placement = "auto",

    offset = 10,

    delay = 150,

    disabled = false,

    maxWidth = 280,

    zIndex = 9999
}) => {

    const targetRef = useRef(null);

    const tooltipRef = useRef(null);

    const timerRef = useRef(null);

    const [visible, setVisible] = useState(false);

    const {
        top,
        left,
        placement: finalPlacement,
        transform
    } = useTooltipPosition({

        targetRef,

        tooltipRef,

        placement,

        offset,

        visible

    });

    const showTooltip = () => {

        if(disabled) return;

        clearTimeout(timerRef.current);

        timerRef.current = setTimeout(()=>{

            setVisible(true);

        },delay);

    };

    const hideTooltip = ()=>{

        clearTimeout(timerRef.current);

        setVisible(false);

    };

    useEffect(()=>{

        return ()=>{

            clearTimeout(timerRef.current);

        }

    },[]);

    return(

        <TooltipWrapper

            ref={targetRef}

            onMouseEnter={showTooltip}

            onMouseLeave={hideTooltip}

            onFocus={showTooltip}

            onBlur={hideTooltip}

            tabIndex={0}

        >

            {children}

            {

                visible && createPortal(

                    <TooltipContainer

                        ref={tooltipRef}

                        top={top}

                        left={left}

                        transform={transform}

                        zIndex={zIndex}

                    >

                        <TooltipBubble

                            visible={visible}

                            maxWidth={maxWidth}

                        >

                            {content}

                            <TooltipArrow

                                placement={finalPlacement}

                            />

                        </TooltipBubble>

                    </TooltipContainer>,

                    document.body

                )

            }

        </TooltipWrapper>

    );

};

export default Tooltip;